import React from 'react';
import styled from 'styled-components';
import { Heading, Text } from '@alefeducation/ui-elements-library-core';
import { getSidebarWidth } from './roles.styled';
import { useRolesContext } from './context/RolesContext';
import {
  CategoryGroupName,
  RoleCategory,
} from '../../apollo/queries/getAllRoles.queries';
import { QUICK_ACCESS, SYSTEM_ROLES } from '../../utils/constants';

const StyledContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid ${({ theme }: any) => theme.colors.primary[10]};

  ${getSidebarWidth};
`;

const NavItem = styled.div<{ selected: boolean }>`
  height: 54px;
  width: 186px;
  padding: 15px 28px;
  cursor: pointer;
  display: flex;
  align-items: center;

  ${({ selected, theme }) =>
    selected ? `background-color: ${theme.colors.subjects.english[30]}` : ''};

  :hover {
    background-color: ${({ theme }: any) => theme.colors.subjects.english[30]};
  }
`;

const SelectionDot = styled.span`
  margin-left: 10px;
  background-color: ${({ theme }: any) => theme.colors.interactive[100]};
  height: 10px;
  width: 10px;
  border-radius: ${({ theme }: any) => theme.radii.full};
  display: block;
`;

const StyledCategoryGroup = styled(Text)`
  display: block;
  padding-left: 28px;
  padding-top: 15px;
  padding-bottom: 14px;
`;

const groupTitle: { [key: string]: string } = {
  [CategoryGroupName.ROLE_BUNDLE]: QUICK_ACCESS,
  [CategoryGroupName.MODULE]: SYSTEM_ROLES,
};

const RolesSidebar = () => {
  const {
    roleSelectionViewModel,
    selectedRolesCategories,
    onCategorySelect,
    selectedCategory,
  } = useRolesContext();

  const renderCategories = (
    categories: RoleCategory[],
    categoryGroupName: string,
  ) => {
    const getIsSelected = (categoryName: string) => {
      return (
        selectedCategory.categoryGroupName === categoryGroupName &&
        selectedCategory.categoryName === categoryName
      );
    };
    const ignoredRoleCategories = ['EMarking'];
    return categories
      .filter((c) => !ignoredRoleCategories.includes(c.categoryName))
      .map(({ categoryName, roles }) => (
        <NavItem
          id={categoryName.replace(' ', '')}
          key={`${categoryGroupName}-${categoryName}`}
          selected={getIsSelected(categoryName)}
          onMouseEnter={() => {
            onCategorySelect({
              categoryName,
              categoryGroupName,
              roles,
            });
          }}
        >
          <Heading variant="heading-small">{categoryName}</Heading>
          {selectedRolesCategories.includes(categoryName) && (
            <SelectionDot data-testid="category-dot" />
          )}
        </NavItem>
      ));
  };

  return (
    <StyledContainer>
      {roleSelectionViewModel.map(({ categoryGroupName, categories }) => (
        <div key={categoryGroupName}>
          <StyledCategoryGroup variant="body-medium" color="#949494">
            {groupTitle[categoryGroupName] || categoryGroupName}
          </StyledCategoryGroup>
          {renderCategories(categories, categoryGroupName)}
        </div>
      ))}
    </StyledContainer>
  );
};

export default RolesSidebar;
